import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

const useStyles = makeStyles((theme: Theme) => ({
	donationCard: {
		marginTop: theme.spacing(2),
		padding: theme.spacing(2),
		background: '#f7faf7',
		borderRadius: '8px',
	},
	donationTitle: {
		margin: 0,
		fontWeight: 700,
		color: '#1f4d2e',
	},
	donationText: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1.5),
		color: '#35513f',
		lineHeight: 1.6,
	},
	donationButton: {
		textTransform: 'none',
		fontWeight: 700,
	},
}));

const Don = memo(() => {
	const classes = useStyles();

	return (
		<Paper className={classes.donationCard} elevation={0}>
			<h3 className={classes.donationTitle}>Faire un don</h3>
			<p className={classes.donationText}>
				Soutenez nos actions en contribuant a la collecte de dons des visiteurs.
			</p>
			<Button
				variant="contained"
				color="success"
				className={classes.donationButton}
			>
				Faire un don
			</Button>
		</Paper>
	);
});

export default Don;

